export default __webpack_public_path__ + "static/media/23.09ab4d26.png";